import { DropdownsUtility } from "./html/dropdowns.utility";
import { OptionInputsUtility } from "./html/optionInputs.utility";
import { PanelsUtility } from "./html/panels.utility";
import { TelerikUtility } from "./telerik.utility";

/**
 * Hides a Telerik data grid's container and moves the actual data grid element into a placeholder element, useful when a grid needs to be relocated in the DOM without losing its Telerik client-side state.
 * @param dataGridSelector Selector or jQuery object for the container currently wrapping the data grid
 * @param placeHolderSelector Selector or jQuery object for the destination element the data grid should be appended to
 */
function moveDataGridToPlaceholder(dataGridSelector: string | JQuery<any>, placeHolderSelector: string | JQuery<any>) {
    let jDataGridContainer = jQuery(dataGridSelector);
    jDataGridContainer.hide();

    let jDataGrid = TelerikUtility.getDataGridFromContainer(jDataGridContainer);
    if (jDataGrid.length > 0) {
        let jPlaceHolder = jQuery(placeHolderSelector);
        jPlaceHolder.show().append(jDataGrid);
    }
}

/**
 * Hides a content container and moves its children into a placeholder element, caching the children in the container's jQuery data if they were already removed from the DOM so they can be restored on a subsequent call.
 * @param contentContainerSelector Selector or jQuery object for the container whose contents should be moved
 * @param placeHolderSelector Selector or jQuery object for the destination element the contents should be appended to
 */
function moveContainerContentsToPlaceHolder(contentContainerSelector: string | JQuery<any>, placeHolderSelector: string | JQuery<any>) {
    let jContentContainer = jQuery(contentContainerSelector);
    jContentContainer.hide();

    // ensure children are not removed from the DOM, if so, get them from the container's data
    let jContents = jContentContainer.children();
    if (jContents.length === 0) {
        jContents = jContentContainer.data('contents') || [];
    } else {
        jContentContainer.data('contents', jContents);
    }

    let jPlaceHolder = jQuery(placeHolderSelector);
    if (jPlaceHolder.length > 0) {
        for (const content of jContents) {
            let jContent = jQuery(content);
            jPlaceHolder.append(jContent);
        }
        jPlaceHolder.show();
        jContentContainer.show();
    }
}

export {
    PanelsUtility as Panel,
    DropdownsUtility as Dropdown,
    OptionInputsUtility as OptionInput,
    moveDataGridToPlaceholder,
    moveContainerContentsToPlaceHolder,
}
